import Env from '@/common/constants/Env.json'
import EnvProd from '@/common/constants/Env_prod.json'
import EnvStage from '@/common/constants/Env_stage.json'
import queryString from 'query-string'
import Util from "@/common/utils/Util"
// import _ from "lodash";

let CODE_ENV_LIST = Env

if (process.env.VUE_APP_MODE === 'production') {
  CODE_ENV_LIST = EnvProd
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = EnvStage
}

const LOGIN_TYPE = {
  USER: {
    name: '학부모/일반 로그인',
    value: 1
  },
  MANAGER: {
    name: '매니저 로그인',
    value: 2
  }
}

const TERMS_TYPE = {
  TERMS: 1,
  PRIVACY: 2
}

const USER_TYPE = {
  PARENT: 1,
  NORMAL: 2,
  MANAGER: 3
}

const SCHEDULE_STATUS = {
  BEFORE: 1,
  DURING: 2,
  AFTER: 3
}

const DRIVING_TYPE = {
  ON: 1,
  OFF: 2
}

const CONFIRM_TYPE = {
  ALERT: 0,
  CONFIRM: 1,
  CARNO:100,
  PERIOD: 101,
  DRIVINGTYPE: 102,
  CHILD_IMAGE: 200,
  STATION: 300,
  DELETE: 400,
  FINDID: 1001,
  MARKETING: 1002,
  LOGOUT: 1003,
  WITHDRAW: 1004,
  ALLOWAUTH: 9000,
  UPDATE: 9001
}

const TAB_TYPE = {
  FINDID: 1,
  FINDPWD: 2,
  SCHEDULEDETAIL: 3
}

const HEADER_ICON_TYPE = {
  MAP: 1,
  INFO: 2,
  SETTING: 3,
  LOGOUT: 4
}

const AGENCY_TYPE = {
  ACADEMY: 1,
  AGENCY: 2
}

const BOARD_TYPE = {
  NOTICE_PARENT: 1,
  NOTICE_NORMAL: 2,
  FAQ_PARENT: 4,
  FAQ_NORMAL: 5,
  INQUIRE: 7
}

const CODE_SERVICE_PROGRESS_STATUS = {
  A: {
    1: {
      label: '컨설팅 진행 (구두 협의)',
      value: 1,
      status: 1,
      description: '기업의 전기사용패턴 분석하여 컨설팅 기획 및 팀원을 배정합니다.'
    },
    2: {
      label: '서류 안내 및 현장조사',
      value: 2,
      status: 2,
      description: '서류안내는 한전에 제출되는 서류가 동반되며, 현장조사는 각 설비마다 체크를해서 조사를 실시합니다.'
    },
    3: {
      label: '서류 수령 중',
      value: 3,
      status: 2,
      description: '서류제출은 안내드린 서류와, 현장조사에 기반된 추가적인 자료를 추합하여 제출을 완료합니다.'
    },
    4: {
      label: '한전 서류 제출',
      value: 4,
      status: 3,
      description: '현장 담당자가 방문하여 현장 검토 및 추가적인 변경에 대한 공사가 필요할시 실시합니다.'
    },
    5: {
      label: '접수중',
      value: 5,
      status: 3,
      description: ''
    },
    6: {
      label: '한전 승인',
      value: 6,
      status: 3,
      description: '전반적인 서류 검토와 현장 실사 및 공사가 완료 후 승인이 이루어집니다.'
    },
    7: {
      label: '한전 실사',
      value: 7,
      status: 4,
      description: '현장 담당자가 방문하여 현장 검토 및 추가적인 변경에 대한 공사가 필요할시 실시합니다.'
    },
    8: {
      label: '변경 확인중',
      value: 8,
      status: 5,
      description: ''
    },
    9: {
      label: '절감보고 및 사후관리',
      value: 9,
      status: 6,
      description: '매월 사용하는 전력비절감 분석,보고 및 모니터링을 지속적인 맞춤형 관리를 합니다.'
    }
  },
  B: {
    1: {
      label: '컨설팅 진행 (구두 협의)',
      value: 1,
      status: 1,
      description: '기업의 전기사용패턴 분석하여 컨설팅 기획 및 팀원을 배정합니다.'
    },
    2: {
      label: '서류 안내 및 현장조사',
      value: 2,
      status: 12,
      description: '서류안내는 한전에 제출되는 서류가 동반되며, 현장조사는 각 설비마다 체크를해서 조사를 실시합니다.'
    },
    3: {
      label: '서류 수령 중',
      value: 3,
      status: 2,
      description: ''
    },
    4: {
      label: '한전 서류 제출',
      value: 4,
      status: 3,
      description: '서류제출은 안내드린 서류와, 현장조사에 기반된 추가적인 자료를 추합하여 제출을 완료합니다.'
    },
    5: {
      label: '접수중',
      value: 5,
      status: 3,
      description: ''
    },
    6: {
      label: '한전 승인',
      value: 6,
      status: 3,
      description: '전반적인 서류 검토와 현장 실사 및 공사가 완료 후 승인이 이루어집니다.'
    },
    7: {
      label: '전기 공사',
      value: 7,
      status: 4,
      description: ''
    },
    8: {
      label: '변경 확인중',
      value: 8,
      status: 4,
      description: ''
    },
    9: {
      label: '한전 2차 서류 제출',
      value: 9,
      status: 3,
      description: '서류제출은 안내드린 서류와, 현장조사에 기반된 추가적인 자료를 추합하여 제출을 완료합니다.'
    },
    10: {
      label: '접수중',
      value: 10,
      status: 3,
      description: ''
    },
    11: {
      label: '전기 공사',
      value: 11,
      status: 4,
      description: ''
    },
    12: {
      label: '변경 확인중',
      value: 12,
      status: 5,
      description: ''
    },
    13: {
      label: '절감보고 및 사후관리',
      value: 13,
      status: 6,
      description: '매월 사용하는 전력비절감 분석,보고 및 모니터링을 지속적인 맞춤형 관리를 합니다.'
    }
  },
  C: {
    1: {
      label: '컨설팅 진행 (구두 협의)',
      value: 1,
      status: 1,
      description: '기업의 전기사용패턴 분석하여 컨설팅 기획 및 팀원을 배정합니다.'
    },
    2: {
      label: '서류 안내 및 현장조사',
      value: 2,
      status: 2,
      description: '서류안내는 한전에 제출되는 서류가 동반되며, 현장조사는 각 설비마다 체크를해서 조사를 실시합니다.'
    },
    3: {
      label: '서류 수령 중',
      value: 3,
      status: 2,
      description: ''
    },
    4: {
      label: '한전 서류 제출',
      value: 4,
      status: 3,
      description: '서류제출은 안내드린 서류와, 현장조사에 기반된 추가적인 자료를 추합하여 제출을 완료합니다.'
    },
    5: {
      label: '접수중',
      value: 5,
      status: 3,
      description: ''
    },
    6: {
      label: '한전 승인',
      value: 6,
      status: 3,
      description: '전반적인 서류 검토와 현장 실사 및 공사가 완료 후 승인이 이루어집니다.'
    },
    7: {
      label: '전기 공사',
      value: 7,
      status: 4,
      description: ''
    },
    8: {
      label: '변경 확인중',
      value: 8,
      status: 4,
      description: ''
    },
    9: {
      label: '한전 2차 서류 제출',
      value: 9,
      status: 3,
      description: '서류제출은 안내드린 서류와, 현장조사에 기반된 추가적인 자료를 추합하여 제출을 완료합니다.'
    },
    10: {
      label: '접수중',
      value: 10,
      status: 3,
      description: ''
    },
    11: {
      label: '전기 공사',
      value: 11,
      status: 4,
      description: ''
    },
    12: {
      label: '변경 확인중',
      value: 12,
      status: 4,
      description: ''
    },
    13: {
      label: '한전 3차 서류 제출',
      value: 13,
      status: 3,
      description: '서류제출은 안내드린 서류와, 현장조사에 기반된 추가적인 자료를 추합하여 제출을 완료합니다.'
    },
    14: {
      label: '접수중',
      value: 14,
      status: 3,
      description: ''
    },
    15: {
      label: '전기 공사',
      value: 15,
      status: 4,
      description: ''
    },
    16: {
      label: '변경 확인중',
      value: 16,
      status: 5,
      description: ''
    },
    17: {
      label: '절감보고 및 사후관리',
      value: 17,
      status: 6,
      description: '매월 사용하는 전력비절감 분석,보고 및 모니터링을 지속적인 맞춤형 관리를 합니다.'
    }
  }
}

const CODE_SERVICE_TYPE = {
  ELECT: {
    label: '전력비 절감',
    value: 1
  },
  LABOR: {
    label: '노무, 인증',
    value: 2
  },
  LAB: {
    label: '연구소 관리',
    value: 3
  }
}

let windowObj
let vmFunction
let vmFunctionName
// let vmFunctionName
window.addEventListener('message', function ({data}) {
  if (!Util.isEmpty(data.operateName) && data.operateName === vmFunctionName) {
    vmFunction(data.data)
    if (windowObj) {
      windowObj.close();
    }
  }


  // vmFunction(params)
}, false)

const ConstCode = function () {
  return {
    CODE_ENV_LIST,
    LOGIN_TYPE,
    TERMS_TYPE,
    USER_TYPE,
    SCHEDULE_STATUS,
    DRIVING_TYPE,
    CONFIRM_TYPE,
    TAB_TYPE,
    HEADER_ICON_TYPE,
    AGENCY_TYPE,
    BOARD_TYPE,
    CODE_SERVICE_PROGRESS_STATUS,
    CODE_SERVICE_TYPE,
    openDaumPostcode: function (callBackFunction = {}) {
      let url = CODE_ENV_LIST.DAUM_POSTCODE_REQ_URL
      vmFunction = callBackFunction
      vmFunctionName = 'DAUM_POSTCODE'
      windowObj = window.open('about:blank')
      windowObj.location.href = `${url}`;
    },

  }
}
export default ConstCode()
